import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, map, of, shareReplay } from 'rxjs';
import { APP_VERSION } from '../../../environments/version';

@Injectable({ providedIn: 'root' })
export class VersionService {
    private readonly http = new HttpClient(inject(HttpBackend));
    readonly version$ = this.http.get<unknown>('assets/version.generated.json').pipe(
        map((value) => {
            if (
                typeof value !== 'object' ||
                value === null ||
                !('version' in value) ||
                typeof value.version !== 'string' ||
                !/^\d+\.\d+\.\d+(?:[-+][\w.+-]+)?$/.test(value.version)
            ) {
                return APP_VERSION.version;
            }
            return value.version;
        }),
        catchError(() => of(APP_VERSION.version)),
        shareReplay({ bufferSize: 1, refCount: false })
    );
}
